import { FiGithub, FiLinkedin, FiTwitter } from "react-icons/fi";
import AppFooterCopyright from "./AppFooterCopyright";

const socialLinks = [
  {
    id: 1,
    icon: <FiLinkedin />,
    url: "https://www.linkedin.com/in/rahul-ganesh-marathervar/",
  },
  {
    id: 2,
    icon: <FiGithub />,
    url: "https://github.com/RahulG2202",
  },
  {
    id: 3,
    icon: <FiTwitter />,
    url: "https://x.com/RahulGN22",
  },
];

const AppFooter = () => {
  return (
    <div className="container mx-auto">
      <div className="mt-20 border-t-2 border-black pb-8 pt-20 sm:pt-30">
        {/* Footer social links */}
        <div className="mb-12 flex flex-col items-center justify-center font-general-regular sm:mb-28">
          <p className="mb-5 text-3xl text-black sm:text-4xl">
            Follow me
          </p>
          <ul className="flex gap-4 sm:gap-8">
            {socialLinks.map((link) => (
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                key={link.id}
                className="cursor-pointer border-2.5 border-black bg-white p-4 text-black duration-300 hover:bg-black hover:text-white"
              >
                <i className="text-xl sm:text-2xl md:text-3xl">{link.icon}</i>
              </a>
            ))}
          </ul>
        </div>

        <AppFooterCopyright />
      </div>
    </div>
  );
};

export default AppFooter;
